import { Pagination } from '../types/Pagination';

export const getPage = ({ offset, limit }: Pagination) => Math.floor(offset / limit) + 1;

export const getPageCount = ({ totalCount, limit }: Pagination) =>
  totalCount && limit ? Math.ceil(totalCount / limit) : 0;

export const getOffset = (page: number, limit: number) => (page - 1) * limit;
